import React from 'react';

const ArticleSidebar = () => {
  const relatedTopics = [
    "The Best Time to Diagnose Vehicle Issues",
    "AI vs. Traditional Diagnostics: What's the Difference?",
    "8 Steps to Understanding Your Vehicle's Health",
    "10 Warning Signs Your Car Needs Attention",
    "How to Prepare Your Vehicle for AI Analysis"
  ];

  const diagnosticTools = [
    "Dashboard Light Guide",
    "Engine Health Analysis",
    "Fluid Level Check",
    "Brake System Diagnostics",
    "Transmission Analysis"
  ];

  return (
    <aside className="lg:w-80 lg:ml-8">
      <div className="sticky top-8 space-y-8">
        
        {/* More in Diagnostics */}
        <div className="bg-white rounded-lg shadow-md border border-gray-200 p-6">
          <h3 className="text-lg font-bold text-gray-900 mb-4">MORE IN DIAGNOSTICS</h3>
          <ul className="space-y-3">
            {relatedTopics.map((topic, index) => (
              <li key={index}>
                <a 
                  href="#" 
                  className="text-blue-600 hover:text-blue-800 text-sm transition-colors duration-200 block"
                >
                  {topic}
                </a>
              </li>
            ))}
            <li className="pt-2">
              <a 
                href="#" 
                className="text-blue-600 hover:text-blue-800 text-sm font-medium transition-colors duration-200"
              >
                See all →
              </a>
            </li>
          </ul>
        </div>

        {/* Diagnostic Tools */}
        <div className="bg-white rounded-lg shadow-md border border-gray-200 p-6">
          <h3 className="text-lg font-bold text-gray-900 mb-4">DIAGNOSTIC TOOLS</h3>
          <ul className="space-y-3">
            {diagnosticTools.map((tool, index) => (
              <li key={index}>
                <a 
                  href="#" 
                  className="text-blue-600 hover:text-blue-800 text-sm transition-colors duration-200 block"
                >
                  {tool}
                </a>
              </li>
            ))}
          </ul>
        </div>

        {/* Try Dash AI */}
        <div className="bg-gradient-to-br from-blue-600 to-blue-700 rounded-lg p-6 text-white">
          <h3 className="text-lg font-bold mb-3">Try Dash AI Today</h3>
          <p className="text-blue-100 text-sm mb-4">
            Get instant AI-powered analysis of your vehicle's condition. 
            Upload your dashboard and VIN photos for comprehensive diagnostics.
          </p>
         
        </div>

        {/* Statistics */}
        <div className="bg-white rounded-lg shadow-md border border-gray-200 p-6">
          <h3 className="text-lg font-bold text-gray-900 mb-4">DASH AI STATS</h3>
          <div className="space-y-4">
            <div className="flex justify-between items-center">
              <span className="text-gray-600 text-sm">Vehicles Analyzed</span>
              <span className="font-bold text-gray-900">50,000+</span>
            </div>
            <div className="flex justify-between items-center">
              <span className="text-gray-600 text-sm">Accuracy Rate</span>
              <span className="font-bold text-green-600">97.3%</span>
            </div>
            <div className="flex justify-between items-center">
              <span className="text-gray-600 text-sm">Average Analysis Time</span>
              <span className="font-bold text-gray-900">2.1s</span>
            </div>
            <div className="flex justify-between items-center">
              <span className="text-gray-600 text-sm">User Satisfaction</span>
              <span className="font-bold text-blue-600">4.9/5</span>
            </div>
          </div>
        </div>

        {/* Newsletter Signup */}
        <div className="bg-gray-50 rounded-lg p-6">
          <h3 className="text-lg font-bold text-gray-900 mb-3">Stay Updated</h3>
          <p className="text-gray-600 text-sm mb-4">
            Get the latest AI diagnostic insights, vehicle tips, and platform updates.
          </p>
          <div className="space-y-3">
            <input 
              type="email" 
              placeholder="Enter your email" 
              className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
            <button className="w-full bg-blue-600 text-white py-2 px-4 rounded-lg font-semibold hover:bg-blue-700 transition-colors duration-200">
              Subscribe
            </button>
          </div>
        </div>

      </div>
    </aside>
  );
};

export default ArticleSidebar;
